import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { FILTER_TYPES } from '_constants/reports';
import { theme } from '_constants/theme';
import { hexToRGBA } from '_helpers/theme';

import Select from 'components/atomic/controls/Select';

const StyledContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  .base-select-container {
    .base-select__control {
      .base-select__value-container {
        .base-select__input-container {
          font-weight: 500;
        }

        .base-select__single-value {
          font-weight: 500;
        }

        .base-select__placeholder {
          font-weight: 500;
        }
      }
    }

    .base-select__menu {
      .base-select__menu-list {
        .base-select__option {
          font-weight: 500;
          color: ${theme.colors.gray.primary};

          &.base-select__option--is-selected {
            background-color: ${theme.colors.indigo.primary};
          }
        }
      }
    }
  }
`;

const TypeFilter = ({ name, value = new Date(), onSelect }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    onSelect({ [name]: value });
  };

  return (
    <StyledContainer>
      <Select
        small
        textColor={theme.colors.gray.secondary}
        backgroundColor={hexToRGBA(theme.colors.gray.secondary, 0.08)}
        name={name}
        value={value}
        options={[
          { title: 'Month to Date', value: FILTER_TYPES.monthToDate },
          { title: 'Last Month', value: FILTER_TYPES.lastMonth },
          { title: 'Last 3 Month', value: FILTER_TYPES.lastThreeMonth },
          { title: 'Year to Date', value: FILTER_TYPES.yearToDate },
          { title: 'Date Range', value: FILTER_TYPES.dateRange },
          { title: 'Month Range', value: FILTER_TYPES.monthRange },
        ]}
        onChange={handleChange}
      />
    </StyledContainer>
  );
};

TypeFilter.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  onSelect: PropTypes.func,
};

export default TypeFilter;
